




import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Point from "@/utils/point";

@Component
export default class MyCanvas extends Vue {
  @Prop() private points!: Array<Point>;
  @Prop() private completed!: Array<Array<Point>>;
  @Prop() private width!: number;
  @Prop() private height!: number;
  @Prop() private close!: boolean;

  selectPoint(e: MouseEvent) {
    this.$emit("selected-point", { x: e.offsetX, y: e.offsetY });
  }

  @Watch("close")
  closePath() {
    this.renderCanvas(this.points);
  }

  @Watch("points")
  renderCanvas(value: Array<Point>) {
    const context = this.context;
    if (context) {
      if (value.length > 0) {
        context.clearRect(0, 0, this.width, this.height);
        context.beginPath();
        if (value.length === 1) {
          context.arc(value[0].x, value[0].y, 1, 0, 2 * Math.PI, true);
          context.fill();
        } else {
          context.moveTo(value[0].x, value[0].y);
          for (let index = 1; index < value.length; index++) {
            const point = value[index];
            context.lineTo(point.x, point.y);
          }
          if (this.close) {
            context.closePath();
          }
          context.stroke();
        }
      }
      this.drawCompleted(context);
    }
  }

  private drawCompleted(context: CanvasRenderingContext2D) {
    for (let index = 0; index < this.completed.length; index++) {
      const completedArray = this.completed[index];
      context.beginPath();
      const firstPoint = completedArray[0];
      context.moveTo(firstPoint.x, firstPoint.y);
      for (
        let pointIndex = 1;
        pointIndex < completedArray.length;
        pointIndex++
      ) {
        const point = completedArray[pointIndex];
        context.lineTo(point.x, point.y);
      }
      context.closePath();
      context.stroke();
    }
  }

  get context() {
    const canvas = this.$refs.canvas as HTMLCanvasElement;
    return canvas.getContext("2d");
  }

  mounted() {
    this.renderCanvas(this.points);
  }
}
